//Turn on/off the notification
export const Show = false;

//Notification message
export const Anouncment = "This is the announcement!";